import React from 'react';

import { Icon } from '@chakra-ui/react';

export const NotifyIcon = props => (
  <Icon viewBox="0 0 192 194" color="inherit" h="full" w="full" {...props}>
    <g transform="translate(-376 -306)">
      <g>
        <g>
          <g>
            <g>
              <path
                d="M388.741 376.394C384.718 377.69 382.506 382.001 383.802 386.024 384.431 387.979 385.821 389.6 387.657 390.52L444.955 419.183 444.434 455.443C444.418 459.715 447.868 463.191 452.14 463.208 453.282 463.212 454.412 462.963 455.447 462.479L492.023 445.336 550.816 473.149C553.147 474.256 555.877 474.133 558.098 472.819 560.311 471.509 561.717 469.175 561.842 466.607L566.093 326.419C566.223 323.895 565.094 321.471 563.077 319.946 561.048 318.417 558.4 317.976 555.986 318.767M549.966 460.669 495.726 434.419C493.702 433.467 491.359 433.467 489.335 434.419L457.189 450.136 457.792 416.947C457.817 414.116 456.225 411.518 453.691 410.255L401.179 385.24 554.094 332.509 549.979 460.669ZM487.593 415.247 538.13 364.737C540.146 362.749 540.146 358.675 538.13 356.673 536.073 354.684 532.809 354.684 530.752 356.673L479.433 407.457C477.456 409.567 477.456 412.849 479.433 414.959 482.217 417.949 486.592 416.248 487.593 415.247Z"
                stroke="currentColor"
                strokeWidth={4}
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
);
